import addBet from './addBet';

export default addBet;
